<template>
  <div>
    <abstractTable  
      :columns="medicalMachinesColumns"
      :classes="'ui tablet very compact center aligned celled table'"
      :paginationEnable="false"
      :data="computedMedicalMachines()"
      :key="tableKeyCounter"
    >
      <!-- <template slot="table-column">
        <th> {{ $t('actions') }} </th>
      </template>
      <template slot="table-row-after" slot-scope="props">
        <td style="width: 175px">
          <div 
            class="ui icon red very compact mini button" 
            @click="deattachMedicalMachine(props.row.id)"
          >
            Deattach
          </div>
        </td>
      </template> -->
    </abstractTable>
  </div>  
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    medicalMachines: { type: Array, requried: true },
    roomId: { type: Number, required: true }
  },
  data() {
    return {
      tableKeyCounter: 0
    }
  },
  computed: {
    medicalMachinesColumns () {
      return [
        { fieldName: 'name', header: this.$t('name'), show: true, filterable: false },
        {
          fieldName: 'origin_country',
          header: 'Origin Country',
          show: true,
          filterable: false
        },
        {
          fieldName: 'unit_measurement_name',
          header: 'unit Measurement Name',
          show: true,
          filterable: false
        },
        { fieldName: 'id', header: this.$t('id'), show: false, filterable: false }
      ]
    }
  },
  methods: {
    computedMedicalMachines () {
      let formaltedMedicalMachines = []

      window._.each(this.medicalMachines, medicalMachine => {
        formaltedMedicalMachines.push({
          id: medicalMachine.id,
          name: medicalMachine.name || '-',
          origin_country: medicalMachine.origin_country || '-',
          // unit_measurement_name: medicalMachine.unit_measurement_id ?
          //   this.unitMeasurements.find(medicalMachine.unit_measurement_id).name : '-',
        })
      })

      return formaltedMedicalMachines
    },
    deattachMedicalMachine(medicalMachineId) {
      this.$http.post(`rooms/${this.roomId}/medical-machines/deattach`, {
        clinic_id: this.getClinicId(),
        medical_machine_ids: [medicalMachineId]
      }).then(response => {
        this.medicalMachines = response.data
        ++this.tableKeyCounter
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/rooms/room_components/MedicalMachines.vue